var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['o-feed-section-loading',
  _vm.$store.getters.getAcademyData.persona === undefined
    ? 'o-feed-section-loading-upgrade' : '']},[_c('MoleculeFeedSectionLoading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }